// Local Shopify credentials — NOT committed to git (see .gitignore).
// Used as a fallback when env vars can't be picked up (e.g. dev container
// cannot be restarted to reload .env.local). Once env is working, these
// values become dead — env vars always win.
export const SHOPIFY_STORE_DOMAIN_LOCAL = '1ctru1-zs.myshopify.com';
export const SHOPIFY_STOREFRONT_ACCESS_TOKEN_LOCAL = '11afee2e3bebb8771fa5082673722c03';
export const SHOPIFY_ADMIN_API_TOKEN_LOCAL = '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';
